var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DataSource } from '@angular/cdk/table';
import { OnInit } from '@angular/core';
import { MemberResponseInterface, PendingInvitationResponseInterface } from '@careapp/angular-sdk';
import { Store } from '@ngrx/store';
import { RolePipe } from '../../shared/pipes/role.pipe';
import * as actions from '../../store/actions/index';
import * as selectors from '../../store/reducers/index';
import * as moment from 'moment-timezone';
var StaffListComponent = /** @class */ (function () {
    function StaffListComponent(store) {
        var _this = this;
        this.store = store;
        this.tableConfig = [
            {
                key: 'lastName',
                sortable: true,
                title: 'Surname',
                render: function (row) { return row.lastName; }
            },
            {
                key: 'firstName',
                sortable: true,
                title: 'Given Name(s)',
                render: function (row) { return (row ? row.firstName : ''); }
            },
            {
                key: 'email',
                sortable: true,
                title: 'Email',
                render: function (row) { return (row ? row.email : ''); }
            },
            {
                key: 'roles',
                sortable: false,
                title: 'Role',
                render: function (row) {
                    return row && row.permissions
                        ? row.permissions.map(function (r) { return _this.rolePipe.transform(r.role); }).join(',')
                        : '';
                }
            }
        ];
        this.inviteConfig = [
            {
                key: 'email',
                sortable: false,
                title: 'Email',
                render: function (row) { return (row && row.to) || ''; }
            },
            {
                key: 'role',
                sortable: false,
                title: 'Role',
                render: function (row) { return (row && row.role) || ''; }
            },
            {
                key: 'date',
                sortable: false,
                title: 'Sent',
                render: function (row) {
                    return row && row.token ? moment.unix(row.token.iat).fromNow() : '';
                }
            },
            {
                key: 'exp',
                sortable: false,
                title: 'Expiration',
                render: function (row) {
                    return row && row.token ? moment.unix(row.token.exp).fromNow() : '';
                }
            },
            {
                key: 'actions',
                sortable: false,
                title: 'Actions'
            }
        ];
        this.rolePipe = new RolePipe();
    }
    StaffListComponent.prototype.ngOnInit = function () {
        this.loading$ = this.store.select(selectors.getLoadingAll(selectors.STAFF));
        this.error$ = this.store.select(selectors.getError(selectors.STAFF));
        this.store.dispatch(actions.Staff.RequestPageAction());
        this.staff = new StaffDataSource(this.store.select(selectors.getAll(selectors.STAFF)));
        this.invites = new InviteDataSource(this.store.select(selectors.invite.getPending));
        this.page$ = this.store.select(selectors.getPageination(selectors.STAFF));
        this.filter$ = this.store.select(selectors.getFilter(selectors.STAFF));
        this.store.dispatch(new actions.RequestPendingInvitations());
    };
    StaffListComponent.prototype.paginate = function (event) {
        this.store.dispatch(actions.Staff.PageChangeAction(event));
    };
    StaffListComponent.prototype.sort = function (event) {
        if (event.direction) {
            this.store.dispatch(actions.Staff.UpdateFilterAction({
                order: event.active + " " + event.direction.toUpperCase()
            }));
        }
    };
    StaffListComponent.prototype.resendInvite = function (id) {
        this.store.dispatch(new actions.RequestInvitationResendAction({ id: id }));
    };
    StaffListComponent.prototype.cancelInvite = function (id) {
        this.store.dispatch(new actions.RequestInvitationCancelAction({ id: id }));
    };
    return StaffListComponent;
}());
export { StaffListComponent };
var StaffDataSource = /** @class */ (function (_super) {
    __extends(StaffDataSource, _super);
    function StaffDataSource(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    StaffDataSource.prototype.connect = function () {
        return this.data;
    };
    StaffDataSource.prototype.disconnect = function () {
        // lint
    };
    return StaffDataSource;
}(DataSource));
export { StaffDataSource };
var InviteDataSource = /** @class */ (function (_super) {
    __extends(InviteDataSource, _super);
    function InviteDataSource(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    InviteDataSource.prototype.connect = function () {
        return this.data;
    };
    InviteDataSource.prototype.disconnect = function () {
        // lint
    };
    return InviteDataSource;
}(DataSource));
export { InviteDataSource };
